/* src/app/modules/product-labels/basic-round-border-label/basic-round-border-label.component.scss */
/*# sourceMappingURL=basic-round-border-label.component.css.map */
